import React, { useCallback, useRef } from "react";
import { FiVideo, FiVideoOff } from "react-icons/fi";
import { IconButton, Switch } from "@chakra-ui/react";

import { useDevices, useLocalVideoToggle } from "hooks/session";

interface Props {
  disabled?: boolean;
  isSwitch?: boolean;
}

const ToggleVideoButton: React.FC<Props> = ({ disabled, isSwitch }: Props) => {
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  return (
    <>
      {isSwitch ? (
        <Switch
          aria-label="Toggle Video"
          isChecked={isVideoEnabled}
          disabled={!hasVideoInputDevices || disabled}
          onChange={toggleVideo}
        />
      ) : (
        <IconButton
          aria-label="Toggle Video"
          onClick={toggleVideo}
          disabled={!hasVideoInputDevices || disabled}
          icon={isVideoEnabled ? <FiVideo /> : <FiVideoOff />}
        />
      )}
    </>
  );
};

export default ToggleVideoButton;
